import { FC, HtmlHTMLAttributes, MouseEvent, TouchEvent } from 'react';
import classNames from 'classnames';
import { useResizeWidthPanel } from 'src/Hooks';
import { ResizeOptionType } from '..';
import st from './SubMenuContainer.module.scss';

interface ISubMenuContainerProps extends HtmlHTMLAttributes<HTMLDivElement> {
	/** Флаг указывающий на состояния панели ( свернута/развернута ) */
	expanded: boolean;
	/** Флаг запрещающий изменение размеров панели */
	disableResizing?: boolean;
	resizeOptions?: ResizeOptionType;
}

/** Минимальный размер панели ( в px ) */
const SubMenuContainer: FC<ISubMenuContainerProps> = (props) => {
	const {
		id,
		expanded,
		disableResizing = false,
		resizeOptions,
		className,
		children,
		...otherProps
	} = props;

	const [panelRef, onStartResize, dragging] = useResizeWidthPanel(
		expanded,
		resizeOptions,
	);

	const onMouseDown = (e: MouseEvent) => {
		e.preventDefault();
		if (expanded) {
			onStartResize(e.clientX);
		}
	};

	const onTouchStart = (e: TouchEvent) => {
		if (!!expanded && !disableResizing) {
			onStartResize(e.targetTouches[0].clientX);
		}
	};

	const wrapperClasses = classNames(st.rdc_submenu__wrapper, className, {
		[st.expanded]: expanded,
	});

	return (
		<div className={st.rdc_submenu} id={id}>
			<div className={wrapperClasses} ref={panelRef} {...otherProps}>
				{!resizeOptions?.disableResize && (
					<div
						onMouseDown={onMouseDown}
						onTouchStart={onTouchStart}
						className={classNames(st.rdc_submenuResize, {
							[st.disabled]: disableResizing,
							[st.active]: dragging,
						})}
					/>
				)}
				{children}
			</div>
		</div>
	);
};

export default SubMenuContainer;
